/**
 * Build the URL that previews an AI-provenance `document` source file in the
 * existing file viewer (a new-tab, file-level browser preview), used by the
 * review cards' quote-popover "View source" link (LF-5577).
 *
 * File-level open only — a page-anchored, quote-highlighted jump is
 * deliberately deferred (LF-2910 Phase 2): today's viewer is a native browser
 * preview with no text layer and no stored coordinates to anchor a highlight
 * against. The `page` is accepted for forward-compatibility but not yet used.
 *
 * Pure, so the footnote can render it directly as an `<a href>` (copyable,
 * middle-clickable, "open in new tab") rather than a JS-only button, and so
 * it's trivially testable.
 */
export function sourceFileHref(fileId: number, _page?: number): string {
  return `/api/files/${fileId}/download?preview=true`;
}

/**
 * Imperatively open {@link sourceFileHref} in a new tab. Retained for callers
 * that need a click handler; the provenance footnote renders the href as a
 * real link instead.
 */
export function openSourceFile(fileId: number, page?: number): void {
  if (typeof window === 'undefined') return;
  window.open(sourceFileHref(fileId, page), '_blank', 'noopener');
}
